import styles from "./Vouchers.module.css";
import { useEffect, useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApplicationSettings from "../../Store/ApplicationSettings.js";
import { activateVoucher, getTasksGroup } from "../../Services/Requests";
import { TasksAdapter } from "../../Pages/Earn/adapters/TasksAdapter";
// Images
import voucher_bg from "/white_bg.webp";
import VoucherInput from "./VoucherInput";
import { useNotificationStore } from "../../Store/NotificationStore.ts";
import { useModalStore } from "../../Store/ModalStore";
import { TaskCard } from "../Earn/components/TaskCards/TaskCard";
import { Loader } from "../../Components/Loader/Loader";

export default function Vouchers() {
  const tg = window.Telegram.WebApp;
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const { setShowMenubar } = useApplicationSettings((state) => ({
    setShowMenubar: state.setShowMenubar,
  }));
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );

  const setOpen = useModalStore((state) => state.setOpen);
  const handleModalShow = () => {
    setOpen(true);
  };

  const [tasks, setTasks] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getTasksGroup((data) => {
      console.log("Все полученные задания:", data);
      const { individualTasks } = TasksAdapter.adaptTasks(data);
      console.log("Индивидуальные задания:", individualTasks);
      setTasks(individualTasks.find((task) => task.type === "partners"));
      setLoading(false);
    });
  }, []);

  const handleBack = useCallback(() => {
    navigate("/fortune-wheel");
  }, [navigate]);

  const handleActivateVoucher = useCallback(() => {
    const voucherCode = inputRef.current?.value.trim();
    if (!voucherCode) {
      setNotification({
        type: "Error",
        message: "Пожалуйста, введи код ваучера",
      });
      return;
    }

    // Устанавливаем состояние загрузки для кнопки
    tg.MainButton.showProgress();
    tg.MainButton.disable();
    activateVoucher(
      voucherCode,
      (data) => {
        const { amount } = data;

        setNotification({
          type: "Success",
          message: `Поздравляем! Ты получил:`,
          rewards: [{ amount, type: "ticket" }],
        });

        setTimeout(() => {
          tg.MainButton.hideProgress();
          tg.MainButton.enable();
          navigate("/fortune-wheel");
        }, 1500);
      },
      (err) => {
        const errorMessage = err.response.data.detail;
        let displayMessage = "";

        switch (errorMessage) {
          case "Voucher not found":
            displayMessage = "Такого ваучера не существует";
            break;
          case "Voucher already activated":
            displayMessage = "Ваучер уже был активирован";
            break;
          case "Voucher expired":
            displayMessage = "Ваучер закончился";
            break;
          case "User is not subscribed to all partners":
            displayMessage =
              "Чтобы активировать ваучер, нужно быть подписанным на всех партнеров";
            break;
          default:
            displayMessage = "Произошла ошибка при активации ваучера";
        }

        setTimeout(() => {
          tg.MainButton.hideProgress();
          tg.MainButton.enable();

          setNotification({
            type: "Error",
            message: displayMessage,
          });
        }, 1500);
      }
    );
  }, [setNotification, navigate]);

  useEffect(() => {
    tg.MainButton.show();
    tg.MainButton.setText("Активировать");
    tg.MainButton.setParams({
      color: "#83B63A",
      text_color: "#FFFFFF",
    });
    tg.setBottomBarColor("#1F0234");
    tg.MainButton.onClick(handleActivateVoucher);
    return () => {
      tg.MainButton.offClick(handleActivateVoucher);
      tg.MainButton.hide();
    };
  }, [handleActivateVoucher, tg.MainButton]);

  useEffect(() => {
    setShowMenubar(false);
    tg.BackButton.show();
    tg.BackButton.onClick(handleBack);

    return () => {
      tg.BackButton.offClick(handleBack);
    };
  }, [handleBack, tg.BackButton, setShowMenubar]);

  return (
    <div className={styles.container + (loading ? " " + styles.loading : "")}>
      {loading ? (
        <>
          <Loader size="medium" text="" />
        </>
      ) : (
        <div className={styles.vouchersContainer}>
          <div className={styles.voucher_bg_container}>
            <img
              src={voucher_bg}
              alt="voucher_bg"
              className={styles.voucher_bg}
            />
          </div>
          <div className={styles.voucherInputContainer}>
            <VoucherInput ref={inputRef} />
          </div>
          <div className={styles.descriptionContainer}>
            <p className={styles.description}>
              Подробнее о том, как выглядят ваучеры, можно узнать{" "}
              <a
                className={styles.description_link}
                href="https://teletype.in/@dreamcoin/directory"
                target="_blank"
              >
                здесь
              </a>
            </p>
            <p className={styles.descriptionWhite}>
              Чтобы активировать ваучер, будь подписан на все каналы в разделе
              “Партнерские”
            </p>
            <>
              <TaskCard task={tasks} onModalShow={handleModalShow} />
            </>
          </div>
        </div>
      )}
    </div>
  );
}
